module.exports = __webpack_public_path__ + "img/minus_btn.0eeb2996.png";